
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useProfile } from '@/modules/profile/model/edit';
import { ROUTE_NAME_PROFILE } from '@/modules/profile/router';

export default defineComponent({
    name: ROUTE_NAME_PROFILE,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useProfile();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
